import {css} from '@emotion/react'
import styled from '@emotion/styled'

export const POPUP_WIDTH = 390

export const hideBottomSheetClose = css`
  [data-id='OverlayDrawerCloseButton'] {
    display: none;
  }
`

export const Illustration = styled.img`
  display: block;
  width: 100%;
  height: auto;
`
